import { Layout } from 'antd';
import React from 'react';

const { Footer } = Layout;

const CustomFooter = ({ text }) => <Footer style={{ textAlign: 'center' }}>{text}</Footer>;

export default CustomFooter;
